import "./style.css";
import { loadManifest } from "./manifest/merge.js";
import { App } from "./ui/app.js";
import { aiConfig } from "./ai/config.js";

const base = import.meta.env.BASE_URL;

/** Media can be served from elsewhere (CDN) by building with VITE_MEDIA_BASE=https://cdn.example/media/. */
function mediaBase(): string {
  const custom = import.meta.env.VITE_MEDIA_BASE as string | undefined;
  if (!custom) return `${base}media/`;
  return custom.endsWith("/") ? custom : `${custom}/`;
}

async function main(): Promise<void> {
  const host = document.getElementById("app");
  if (!host) return;
  try {
    const read = async (p: string): Promise<unknown> => {
      const res = await fetch(`${base}content/${p}`);
      if (!res.ok) throw new Error(`${p}: ${res.status}`);
      return res.json();
    };
    const manifest = await loadManifest(read);
    const probe = document.createElement("video");
    const app = new App({
      manifest,
      mediaBase: mediaBase(),
      reducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
      supportsWebm: probe.canPlayType('video/webm; codecs="vp9"') !== "",
      storage: window.localStorage,
      loadContent: read,
      ai: aiConfig(import.meta.env as Record<string, string | undefined>, location.search)
    });
    host.replaceChildren(app.root);
    await app.start();
  } catch (err) {
    const p = document.createElement("p");
    p.className = "fatal";
    p.textContent = `Could not load the mall: ${err instanceof Error ? err.message : String(err)}`;
    host.replaceChildren(p);
  }
}

void main();
